import { NationalityService } from "../../services/models/nationality";
const moduleNationality = {
	namespaced: true,
	state: {
		nationalities: [],
		loading: false,
	},
	getters: {
		getNationalities(state) {
			return state.nationalities;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadNationalities(state, nationalities) {
			state.nationalities = nationalities;
		}
	},
	actions: {
		async loadNationalities({ commit, state }) {
			state.loading = true;
			let nationalities = await NationalityService.getAll();
			commit("loadNationalities", nationalities);
			state.loading = false;
		}
	}
}

export default moduleNationality;